/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2026 Valerii Chupurnov. All rights reserved. https://xdsoft.net
 */

// Hebrew (עברית)
export default {
	'Type something': 'הקלד משהו...',
	Advanced: 'מתקדם',
	'About Jodit': 'About Jodit',
	'Jodit Editor': 'Jodit Editor',
	"Jodit User's Guide": "Jodit User's Guide",
	'contains detailed help for using': 'contains detailed help for using.',
	'For information about the license, please go to our website:':
		'For information about the license, please go to our website:',
	'Buy full version': 'Buy full version',
	'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
		'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.',
	Anchor: 'מקום עיגון',
	'Open in new tab': 'פתח בכרטיסיה חדשה',
	'Open in fullsize': 'פתח את העורך בחלון חדש',
	'Clear Formatting': 'נקה עיצוב',
	'Fill color or set the text color': 'שנה צבע טקסט או רקע',
	Redo: 'בצע שוב',
	Undo: 'בטל',
	Bold: 'מודגש',
	Italic: 'נטוי',
	'Insert Unordered List': 'הכנס רשימת תבליטים',
	'Insert Ordered List': 'הכנס רשימה ממוספרת',
	'Align Center': 'מרכז',
	'Align Justify': 'ישר ',
	'Align Left': 'ישר לשמאל',
	'Align Right': 'ישר לימין',
	'Insert Horizontal Line': 'הכנס קו אופקי',
	'Insert Image': 'הכנס תמונה',
	'Insert file': 'הכנס קובץ',
	'Insert youtube/vimeo video': 'הכנס סרטון וידאו מYouTube/Vimeo',
	'Insert link': 'הכנס קישור',
	'Font size': 'גודל גופן',
	'Font family': 'גופן',
	'Insert format block': 'מעוצב מראש',
	Normal: 'רגיל',
	'Heading 1': 'כותרת 1',
	'Heading 2': 'כותרת 2',
	'Heading 3': 'כותרת 3',
	'Heading 4': 'כותרת 4',
	Quote: 'ציטוט',
	Code: 'קוד',
	Insert: 'הכנס',
	'Insert table': 'הכנס טבלה',
	'Decrease Indent': 'הקטן כניסה',
	'Increase Indent': 'הגדל כניסה',
	'Select Special Character': 'בחר תו מיוחד',
	'Insert Special Character': 'הכנס תו מיוחד',
	'Paint format': 'העתק עיצוב',
	'Change mode': 'החלף מצב',
	Margins: 'ריווח',
	top: 'עליון',
	right: 'ימין',
	bottom: 'תחתון',
	left: 'שמאל',
	Styles: 'עיצוב CSS',
	Classes: 'מחלקת CSS',
	Align: 'יישור',
	Right: 'ימין',
	Center: 'מרכז',
	Left: 'שמאל',
	'--Not Set--': '--לא נקבע--',
	Src: 'מקור',
	Title: 'כותרת',
	Alternative: 'כיתוב חלופי',
	Link: 'קישור',
	'Open link in new tab': 'פתח בכרטיסיה חדשה',
	Image: 'תמונה',
	file: 'קובץ',
	'Image properties': 'מאפייני תמונה',
	Cancel: 'ביטול',
	Ok: 'אישור',
	'Your code is similar to HTML. Keep as HTML?':
		'הקוד דומה לHTML, האם להשאיר כHTML',
	'Paste as HTML': 'הדבק כHTML',
	Keep: 'השאר',
	Clean: 'נקה',
	'Insert as Text': 'הכנס כטקסט',
	'Word Paste Detected': 'זוהתה הדבקה מ"וורד"',
	'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?':
		'התוכן המודבק מגיע ממסמך וורד/אקסל. האם ברצונך להשאיר את העיצוב או לנקותו',
	'Insert only Text': 'הכנס טקסט בלבד',
	'File Browser': 'סייר הקבצים',
	'Error on load list': 'שגיאה  בזמן טעינת רשימה',
	'Error on load folders': 'שגיאה בזמן טעינת תקיות',
	'Are you sure?': 'האם אתה בטוח?',
	'Enter Directory name': 'הכנס שם תקיה',
	'Create directory': 'צור תקיה',
	'type name': 'סוג הקובץ',
	'Drop image': 'הסר תמונה',
	'Drop file': 'הסר קובץ',
	'or click': 'או לחץ',
	'Alternative text': 'כיתוב חלופי',
	Browse: 'סייר',
	Upload: 'העלה',
	Background: 'רקע',
	Text: 'טקסט',
	Top: 'עליון',
	Middle: 'מרכז',
	Bottom: 'תחתון',
	'Insert column before': 'הכנס עמודה לפני',
	'Insert column after': 'הכנס עמודה אחרי',
	'Insert row above': 'הכנס שורה מעל',
	'Insert row below': 'הכנס שורה מתחת',
	'Delete table': 'מחק טבלה',
	'Delete row': 'מחק שורה',
	'Delete column': 'מחק עמודה',
	'Empty cell': 'רוקן תא',
	Delete: 'מחק',
	'Strike through': 'קו חוצה',
	Underline: 'קו תחתון',
	Break: 'שבירת שורה',
	'Search for': 'חפש',
	'Replace with': 'החלף ב',
	Replace: 'להחליף',
	Edit: 'ערוך',
	'Vertical align': 'יישור אנכי',
	'Horizontal align': 'יישור אופקי',
	Filter: 'סנן',
	'Sort by changed': 'מין לפי שינוי',
	'Sort by name': 'מיין לפי שם',
	'Sort by size': 'מיין לפי גודל',
	'Add folder': 'הוסף תקייה',
	Split: 'פיצול',
	'Split vertical': 'פיצול אנכי',
	'Split horizontal': 'פיצול אופקי',
	Merge: 'מזג',
	'Add column': 'הוסף עמודה',
	'Add row': 'הוסף שורה',
	Border: 'מסגרת',
	'Embed code': 'הוסף קוד',
	Update: 'עדכן',
	superscript: 'superscript',
	subscript: 'subscript',
	'Cut selection': 'גזור בחירה',
	Paste: 'הדבק',
	'Choose Content to Paste': 'בחר תוכן להדבקה',
	'Chars: %d': 'תווים: %d',
	'Words: %d': 'מילים: %d',
	All: 'הכל',
	'Select %s': 'נבחר: %s',
	'Select all': 'בחר הכל',
	source: 'HTML',
	bold: 'מודגש',
	italic: 'נטוי',
	brush: 'מברשת',
	link: 'קישור',
	undo: 'בטל',
	redo: 'בצע שוב',
	table: 'טבלה',
	image: 'תמונה',
	eraser: 'מחק',
	paragraph: 'פסקה',
	fontsize: 'גודל גופן',
	video: 'וידאו',
	font: 'גופן',
	about: 'עלינו',
	print: 'הדפס',
	underline: 'קו תחתון',
	strikethrough: 'קו חוצה',
	indent: 'הגדל כניסה',
	outdent: 'הקטן כניסה',
	fullsize: 'גודל מלא',
	shrink: 'כווץ',
	hr: 'קו אופקי',
	ul: 'רשימת תבליטים',
	ol: 'רשימה ממוספרת',
	cut: 'חתוך',
	selectall: 'בחר הכל',
	'Open link': 'פתח קישור',
	'Edit link': 'ערוך קישור',
	'No follow': 'ללא מעקב',
	Unlink: 'בטל קישור',
	Eye: 'הצג',
	pencil: 'כדי לערוך',
	' URL': 'כתובת',
	Reset: 'אפס',
	Save: 'שמור',
	'Save as ...': 'שמור בשם...',
	Resize: 'שנה גודל',
	Crop: 'חתוך',
	Width: 'רוחב',
	Height: 'גובה',
	'Keep Aspect Ratio': 'שמור יחס',
	Yes: 'כן',
	No: 'לא',
	Remove: 'הסר',
	Select: 'בחר',
	'You can only edit your own images. Download this image on the host?':
		'רק קבצים המשוייכים שלך ניתנים לעריכה. האם להוריד את הקובץ?',
	'The image has been successfully uploaded to the host!':
		'התמונה עלתה בהצלחה!',
	palette: 'לוח',
	'There are no files': 'אין קבצים בספריה זו.',
	Rename: 'הונגרית',
	'Enter new name': 'הזן שם חדש',
	preview: 'תצוגה מקדימה',
	download: 'הורד',
	'Paste from clipboard': 'להדביק מהלוח',
	"Your browser doesn't support direct access to the clipboard.":
		'הדפדפן שלך לא תומך גישה ישירה ללוח.',
	'Copy selection': 'העתק בחירה',
	copy: 'העתק',
	'Border radius': 'רדיוס הגבול',
	'Show all': 'הצג את כל',
	Apply: 'החל',
	'Please fill out this field': 'נא למלא שדה זה',
	'Please enter a web address': 'אנא הזן כתובת אינטרנט',
	Default: 'ברירת המחדל',
	Circle: 'מעגל',
	Dot: 'נקודה',
	Quadrate: 'הריבוע הזה',
	Find: 'למצוא',
	'Find Previous': 'מצא את הקודם',
	'Find Next': 'חפש את הבא',
	'Insert className': 'הכנס את שם הכיתה',
	'Press Alt for custom resizing': 'לחץ על אלט לשינוי גודל מותאם אישית',
	'License: %s': 'רישיון: %s'
};
